import type { TimelineViewTransform } from "../ViewTransform/transform";

export function applyTimelineStageViewCss(
  stage: HTMLElement | null,
  view: TimelineViewTransform,
): void {
  if (stage === null) {
    return;
  }
  const zoomEl = stage.querySelector<HTMLElement>(".timeline-stage__zoom");
  if (zoomEl === null) {
    return;
  }
  zoomEl.style.setProperty("--timeline-zoom", String(view.zoom));
  zoomEl.style.setProperty("--timeline-pan-x", `${view.panX}px`);
  zoomEl.style.setProperty("--timeline-pan-y", `${view.panY}px`);
}
